/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createChargePointConsumptionFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeAddBackDatedChargePointConsumptionCommand, type AddBackDatedChargePointConsumptionCommand, type ChargePointConsumption, type ProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { HistoryRequestBuilderRequestsMetadata, type HistoryRequestBuilder } from './history/index.js';
// @ts-ignore
import { ManualRequestBuilderRequestsMetadata, type ManualRequestBuilder } from './manual/index.js';
// @ts-ignore
import { ProjectionRequestBuilderRequestsMetadata, type ProjectionRequestBuilder } from './projection/index.js';
// @ts-ignore
import { SessionsRequestBuilderNavigationMetadata, SessionsRequestBuilderRequestsMetadata, type SessionsRequestBuilder } from './sessions/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /chargepoints/{id}/consumption
 */
export interface ConsumptionRequestBuilder extends BaseRequestBuilder<ConsumptionRequestBuilder> {
    /**
     * The history property
     */
    get history(): HistoryRequestBuilder;
    /**
     * The manual property
     */
    get manual(): ManualRequestBuilder;
    /**
     * The projection property
     */
    get projection(): ProjectionRequestBuilder;
    /**
     * The sessions property
     */
    get sessions(): SessionsRequestBuilder;
    /**
     * RemoveBackDatedChargePointConsumption
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     delete(requestConfiguration?: RequestConfiguration<ConsumptionRequestBuilderDeleteQueryParameters> | undefined) : Promise<void>;
    /**
     * GetChargePointConsumption
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ChargePointConsumption>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ChargePointConsumption | undefined>;
    /**
     * AddBackDatedChargePointConsumption
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Guid>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: AddBackDatedChargePointConsumptionCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Guid | undefined>;
    /**
     * RemoveBackDatedChargePointConsumption
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<ConsumptionRequestBuilderDeleteQueryParameters> | undefined) : RequestInformation;
    /**
     * GetChargePointConsumption
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * AddBackDatedChargePointConsumption
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: AddBackDatedChargePointConsumptionCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * RemoveBackDatedChargePointConsumption
 */
export interface ConsumptionRequestBuilderDeleteQueryParameters {
    consumptionId?: string;
}
/**
 * Uri template for the request builder.
 */
export const ConsumptionRequestBuilderUriTemplate = "{+baseurl}/chargepoints/{id}/consumption";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const ConsumptionRequestBuilderDeleteQueryParametersMapper: Record<string, string> = {
    "consumptionId": "ConsumptionId",
};
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ConsumptionRequestBuilderNavigationMetadata: Record<Exclude<keyof ConsumptionRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    history: {
        requestsMetadata: HistoryRequestBuilderRequestsMetadata,
    },
    manual: {
        requestsMetadata: ManualRequestBuilderRequestsMetadata,
    },
    projection: {
        requestsMetadata: ProjectionRequestBuilderRequestsMetadata,
    },
    sessions: {
        requestsMetadata: SessionsRequestBuilderRequestsMetadata,
        navigationMetadata: SessionsRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ConsumptionRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: "{+baseurl}/chargepoints/{id}/consumption?ConsumptionId={ConsumptionId}",
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        queryParametersMapper: ConsumptionRequestBuilderDeleteQueryParametersMapper,
    },
    get: {
        uriTemplate: ConsumptionRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createChargePointConsumptionFromDiscriminatorValue,
    },
    post: {
        uriTemplate: ConsumptionRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "string",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeAddBackDatedChargePointConsumptionCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
